import { MAX_ZONES_PER_CONDENSER } from 'data/constants';
import { CondenserType, ConfigurationType } from 'data/types';

const DUCTED_CONDENSER_ZONE_CAPACITY = 1;
const DUCTED_ZONE_CAPACITY_MESSAGE =
  'A ducted condenser serves one zone — place another condenser to add a zone.';

export function maxZonesForCondenser(
  condenser: Pick<CondenserType, 'type'>
): number {
  return condenser.type === 'ducted'
    ? DUCTED_CONDENSER_ZONE_CAPACITY
    : MAX_ZONES_PER_CONDENSER;
}

export function condenserHasZoneCapacity(
  condenser: Pick<CondenserType, 'type' | 'zones'>
): boolean {
  return condenser.zones.length < maxZonesForCondenser(condenser);
}

export function condenserZoneCapacityMessage(
  condenser: Pick<CondenserType, 'type'>
): string {
  return condenser.type === 'ducted'
    ? DUCTED_ZONE_CAPACITY_MESSAGE
    : `Each condenser can have at most ${MAX_ZONES_PER_CONDENSER} zones.`;
}

export function configurationZoneCapacityMessage(
  configuration: Pick<ConfigurationType, 'type'>
): string {
  if (configuration.type === 'ducted') return DUCTED_ZONE_CAPACITY_MESSAGE;
  return `Each condenser can have at most ${MAX_ZONES_PER_CONDENSER} zones.`;
}
